import React from 'react';

function Hero() {
  return (
    <section className="hero" id="chi-siamo">
      <div className="hero-bg"></div>
      <div className="hero-content animate-on-scroll">
        <h1 className="hero-title">Adotta un amico,<br/>cambia due vite.</h1>
        <p className="hero-text">
          Al canile Glad Dogs accogliamo cani abbandonati, curandoli con amore e preparando per loro una nuova vita. Il nostro obiettivo è trovare una famiglia perfetta per ognuno di loro, perché ogni cane merita una seconda possibilità.
        </p>
        <div style={{ display: 'flex', gap: '16px' }}>
          <a href="#i-nostri-cani" className="btn btn-primary">Scopri i cani</a>
          <a href="#donazioni" className="btn btn-outline">Scopri come aiutare</a>
        </div>
      </div>
      <div className="hero-image animate-on-scroll">
        <img 
          src="/images/hero_dog_1776854083291.png" 
          alt="Un cane felice in attesa di adozione" 
        />
      </div>
    </section>
  );
}

export default Hero;
